'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('voter-group-edit', {
      url: '/voter-group/edit/:id',
      template: '<voter-group-edit></voter-group-edit>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/portfolio/voter-group-edit/voter-group-edit.routes.js